import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiBusiness } from 'modules/api';

export const fetchEntityAndBusinessTypes = createAsyncThunk(
  'codes/getEntityAndBusinessTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiBusiness.getCombinedBusinessCodes();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
